import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateRouteFormComponent } from './create-route-form.component';
import { SharedModule } from 'app/shared/shared.module';
import { DataPickerModule } from '../data-picker/data-picker.module';
import { CreateRouteFormMapComponent } from './create-route-form-map/create-route-form-map.component';
import { RouteOriginDestinationPopupComponent } from './route-origin-destination-popup/route-origin-destination-popup.component';
import { RouteJobPopupComponent } from './route-job-popup/route-job-popup.component';



@NgModule({
    declarations: [
        CreateRouteFormComponent,
        CreateRouteFormMapComponent,
        RouteOriginDestinationPopupComponent,
        RouteJobPopupComponent
    ],
    exports: [
        CreateRouteFormComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        DataPickerModule,
    ]
})
export class CreateRouteFormModule { }
